import type { BenchmarkUrlParams } from "../types/paramsTypes";

type Tab = BenchmarkUrlParams["tab"];

const tabSet = new Set<Tab>(["0", "1", "2"]);

export const isValidTab = (tab: string): tab is Tab => tabSet.has(tab as Tab);
